// extracted by mini-css-extract-plugin
export default {"customTabContainer":"styles_customTabContainer__bfiTM","tabItemWrapper":"styles_tabItemWrapper__GcbMp","tabItem":"styles_tabItem__V4k3n","active":"styles_active__C-Z1B"};